import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import { InverseClearButton } from '#/shared/components/Styled';
import BaseArrowBackIcon from '#/shared/components/GeneratedIcons/generic/ArrowBack';
import BaseCloseIcon from '#/shared/components/GeneratedIcons/generic/Close';
import BaseArrowLeftIcon from '#/shared/components/GeneratedIcons/generic/ArrowLeft';
import {
  SYSTEM_ALERT_BANNER_HEIGHT,
  MOBILE_MAX_BREAK,
  DESKTOP_MIN_BREAK,
  TOP_BORDER_RADIUS,
  DETAILNAV_BUTTON_WIDTH,
  DETAILNAV_BUTTON_HEIGHT,
  DETAILNAV_BUTTON_VALUE,
} from '#/shared/constants';

export const DetailNavHeaderWrapper = styled.div`
  flex: 1 0 auto;
  height: 50px;
  justify-content: ${props =>
    !props.mobileMode && props.minimized ? 'end' : 'initial'};
  position: relative;
  padding: 0 10px;
  background: ${props => props.theme.navHeaderBg};
  color: ${props => props.theme.navHeaderTitle};
  display: flex;
  align-items: center;
  @media (max-width: ${MOBILE_MAX_BREAK}) {
    top: ${props =>
      props.hasSystemWideAlert &&
      !props.hideMapOnMobile &&
      props.alertBannerIsVisible
        ? SYSTEM_ALERT_BANNER_HEIGHT
        : 0};
  }
  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    border-radius: ${TOP_BORDER_RADIUS};
  }
  @media (any-hover: hover) {
    &:hover {
      cursor: ${props => (props.minimized ? 'pointer' : 'default')};
    }
  }
`;

function handleDetailNavHeaderContentPosition(props) {
  if (!props.mobileMode && !props.hideClose) {
    return `calc(50% - ${DETAILNAV_BUTTON_VALUE / 2}px)`;
  }
  return '50%';
}

function handleDetailNavHeaderContentWidth(props) {
  return `calc(100% - 20px - ${
    DETAILNAV_BUTTON_VALUE * (props.mobileMode || props.hideClose ? 2 : 3)
  }px)`;
}

export const DetailNavHeaderContent = injectIntl(styled.div.attrs(
  ({ minimized, intl }) => ({
    title: !minimized
      ? intl.formatMessage({ id: 'detailview.sidepanel_minimize' })
      : intl.formatMessage({ id: 'detailview.sidepanel_expand' }),
    role: 'heading',
    'aria-level': 1,
  })
)`
  position: absolute;
  left: ${props => handleDetailNavHeaderContentPosition(props)};
  transform: translateX(-50%);
  white-space: nowrap;
  display: flex;
  flex: 1 1 auto;
  font-size: 1.2em;
  padding: ${props => (props.minimized ? '0 .5em 0 .75em' : '0')};
  height: 100%;
  width: ${props => handleDetailNavHeaderContentWidth(props)};
  align-items: center;
  justify-content: center;
  @media (any-hover: hover) {
    &:hover {
      cursor: ${props => (props.mobileMode ? 'default' : 'pointer')};
      opacity: 1;
    }
    ${DetailNavHeaderWrapper}:hover & {
      opacity: 1;
    }
  }
`);

export const PageTitle = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  min-width: 0;
  transform: translateX(
    ${props =>
      !props.hideClose &&
      !props.mobileMode &&
      !props.textOverflow &&
      DETAILNAV_BUTTON_VALUE / 2}px
  );
`;

export const MinMaxCloseWrapper = styled.div`
  display: flex;
  margin-left: auto;
`;

const DetailNavHeaderButton = styled(InverseClearButton).attrs(props => ({
  role: 'link',
  tabIndex: props.hide ? '-1' : '0',
}))`
  flex: 0 0 auto;
  display: ${props => (props.hide ? 'none' : 'flex')};
  justify-content: center;
  align-items: center;
  height: ${DETAILNAV_BUTTON_HEIGHT};
  width: ${DETAILNAV_BUTTON_WIDTH};
  border-radius: 100%;
  @media (any-hover: hover) {
    &:hover {
      background-color: ${props => props.theme.navIconBgHover};
    }
  }
`;

export const BackButton = styled(DetailNavHeaderButton)`
  margin-right: auto;
`;
export const CloseButton = styled(DetailNavHeaderButton)`
  margin-left: 2px;
`;
const MinMaxSidePanelButton = injectIntl(styled(DetailNavHeaderButton).attrs(
  ({ minimized, intl }) => ({
    role: 'button',
    'aria-expanded': !minimized,
    'aria-controls': 'side-panel',
    'aria-label': intl.formatMessage({ id: 'detailview.sidepanel_label' }),
  })
)`
  display: ${props => (props.mobileMode ? 'none' : 'flex')};
  justify-content: ${props => (props.minimized ? 'flex-end' : 'center')};
`);

export const MinSidePanelButton = injectIntl(
  styled(MinMaxSidePanelButton).attrs(({ intl }) => ({
    title: intl.formatMessage({
      id: 'detailview.sidepanel_minimize',
    }),
  }))``
);

export const ExpandSidePanelButton = injectIntl(
  styled(MinMaxSidePanelButton).attrs(({ intl }) => ({
    title: intl.formatMessage({
      id: 'detailview.sidepanel_expand',
    }),
  }))`
    @media (any-hover: hover) {
      ${DetailNavHeaderWrapper}:hover & {
        background-color: ${props => props.theme.navIconBgHover};
      }
    }
  `
);

export const ArrowBackIcon = styled(BaseArrowBackIcon).attrs(props => ({
  role: 'presentation',
  fill: props.theme.navIconFill,
  width: 24,
  height: 24,
}))``;

export const CloseIcon = styled(BaseCloseIcon).attrs(props => ({
  role: 'presentation',
  fill: props.theme.navIconFill,
  width: 24,
  height: 24,
}))``;
export const MinMaxChevronIcon = styled(BaseArrowLeftIcon).attrs(props => ({
  width: 15,
  height: 15,
  fill: props.theme.navIconFill,
}))`
  display: flex;
  flex: 1;
  transform: rotate(0.75turn);
  transform: rotate(${props => (props.$minimized ? '0.25turn' : '0.75turn')});
`;
